import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function uploadWeightApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.WeighingequipmentapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/api/wms/device/weight/scaled"
          },
          {
            key: "apiDocDesc.proUrl",
            value: "https://sop.jtfulfillment.cn/api/wms/device/weight/scaled"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "YL001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/api/wms/device/weight/scaled"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value:
              "https://openapi.jtfulfillment.cn/api/wms/device/weight/scaled"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "STZX0000001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "Content-Type",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.weightDesc506"
            },
            {
              name: "X-DEVICE",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.weightDesc507"
            },
            {
              name: "X-FN",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.weightDesc508"
            },
            {
              name: "X-SN",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.weightDesc509"
            },
            {
              name: "x-client",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.weightDesc510"
            },
            {
              name: "x-token",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.weightDesc511"
            },
            {
              name: "x-user",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.weightDesc512"
            },
            {
              name: "referenceCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.referenceCodeDesc513"
            },
            {
              name: "warehouseCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc514"
            },
            {
              name: "weight",
              type: "DECEMAL",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.weightDesc515"
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "code",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.codeDesc516"
            },
            {
              name: "msg",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.msgDesc517"
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        referenceCode: "UPFOS20251209CN",
        warehouseCode: "SH.001",
        weight: 12.5
      },
      //返回示例
      responseCode: {
        code: "200",
        msg: "操作成功"
      }
    }
  };
}
